import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AccountService } from '@app/reducers/account/account.service';
import { ButtonComponent } from '@sb/ui/button';
import { ToastService } from '@sb/ui/toast/toast.service';

import { DevToolsSectionComponent } from './dev-tools-section.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-dev-tools-chargebee',
  template: `
    <app-dev-tools-section title="Chargebee" storageKey="chargebee">
      <div class="flex flex-wrap gap-2">
        <button sb-button size="sm" (click)="importFromChargeBee()">Import from Chargebee</button>
        <button sb-button size="sm" (click)="pushToChargeBee()">Push to Chargebee</button>
      </div>
    </app-dev-tools-section>
  `,
  imports: [ButtonComponent, DevToolsSectionComponent],
})
export class DevToolsChargebeeComponent {
  private accountService = inject(AccountService);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  importFromChargeBee(): void {
    this.accountService
      .importFromChargeBee()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastService.openSuccess('Account imported from Chargebee');
        },
        error: () => {
          this.toastService.openDanger('Failed to import account from Chargebee');
        },
      });
  }

  pushToChargeBee(): void {
    this.accountService
      .pushToChargeBee()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.toastService.openSuccess('Account pushed to Chargebee');
        },
        error: () => {
          this.toastService.openDanger('Failed to push account to Chargebee');
        },
      });
  }
}
